import {
  DocumentDuplicateIcon,
  EllipsisVerticalIcon,
  PencilSquareIcon
} from '@heroicons/react/24/outline';
import LoadingSpinner from 'components/common/loading-spinner';
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger
} from 'components/layout/popover';
import Tooltip from 'components/layout/tooltip';

type StructureActionsMenuProps = {
  disabled?: boolean;
  duplicating?: boolean;
  onRename: () => void;
  onDuplicate: () => void;
};

const menuItemClassName =
  'flex w-full cursor-pointer items-center gap-2 px-3 py-1.5 text-left text-xs text-neutral-300 hover:bg-neutral-700 hover:text-white';

export default function StructureActionsMenu({
  disabled = false,
  duplicating = false,
  onRename,
  onDuplicate
}: StructureActionsMenuProps) {
  return (
    <Popover placement='bottom-end' returnFocus={false}>
      <PopoverTrigger asChild>
        <button
          type='button'
          aria-label='Structure Actions'
          className='relative cursor-pointer text-neutral-400 hover:text-white disabled:cursor-not-allowed disabled:opacity-50'
          disabled={disabled || duplicating}
        >
          {duplicating ? (
            <LoadingSpinner className='h-4 w-4 animate-spin' />
          ) : (
            <EllipsisVerticalIcon className='h-4 w-4' />
          )}
          <Tooltip
            text={duplicating ? 'Duplicating...' : 'Structure Actions'}
          />
        </button>
      </PopoverTrigger>
      <PopoverContent className='z-50 min-w-[160px] rounded-md bg-neutral-800 py-1 shadow-lg'>
        <PopoverClose className={menuItemClassName} onClick={onRename}>
          <PencilSquareIcon className='h-3.5 w-3.5' />
          <span>Rename</span>
        </PopoverClose>
        <PopoverClose className={menuItemClassName} onClick={onDuplicate}>
          <DocumentDuplicateIcon className='h-3.5 w-3.5' />
          <span>Duplicate</span>
        </PopoverClose>
      </PopoverContent>
    </Popover>
  );
}
